import React from 'react'

interface SingleCardProps {
    title: string;
    data: number | string | undefined;
    units?: string;
    description?: string;
}

export const CardInfo = ({ title, data, units = "", description = "" }: SingleCardProps) => (
    <div className='card-content'>
        <p className='content-title'>{title}</p>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <p className='content-info'>{data} {units}</p>
            {description && (
                <p className='content-description'>{description}</p>
            )}
        </div>
    </div>
)
